
































import {Component, Prop, Watch, Vue} from "vue-property-decorator";
import {PlayerDigit} from "@/classes/Player.ts";
import GameManager from "@/classes/GameManager.ts";

@Component
export default class DigitSelector extends Vue {
    @Prop() public props!: PlayerDigit;
    protected value: number = 0;
    protected guessed: boolean = false;

    public created() {
        this.sync();
    }

    public increment(): void {
        if (this.value === 9) {
            this.value = 0;
        } else {
            this.value++;
        }
        this.playSound();
    }

    public decrement(): void {
        if (this.value === 0) {
            this.value = 9;
        } else {
            this.value--;
        }
        this.playSound();
    }

    public incrementFour(): void {
        if (this.value >= 6) {
            this.value -= 10;
        }
        this.value += 4;
        this.playSound();
    }

    public decrementFour(): void {
        if (this.value <= 3) {
            this.value += 10;
        }
        this.value -= 4;
        this.playSound();
    }

    protected playSound(): void {
        GameManager.playSound("MROLLOV2");
    }

    @Watch("props.value")
    @Watch("props.guessed")
    protected sync(): void {
        this.value = this.props.value;
        this.guessed = this.props.guessed;
    }

    @Watch("value")
    protected changed(): void {
        this.$emit("changed", this.value);
    }
}
